import { render, staticRenderFns } from "./SysConfigList.vue?vue&type=template&id=5dceb192&scoped=true&lang=pug&"
import script from "./SysConfigList.vue?vue&type=script&lang=ts&"
export * from "./SysConfigList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dceb192",
  null
  
)

export default component.exports